import { Component } from '@angular/core';

@Component({
  selector: 'app-selected-all-attributes-dialog',
  templateUrl: './selected-all-attributes-dialog.component.html',
  styleUrls: ['./selected-all-attributes-dialog.component.scss'],
})
export class SelectedAllAttributesDialogComponent {}
